import { NgModule } from '@angular/core'
import { HeaderImageFeatureModule } from './header-image/header-image-feature.module'
import { HeaderImageBackgroundFeatureModule } from './header-image-background/header-image-background-feature.module'
import { FullWidthHeaderFeatureModule } from './full-width-header/full-width-header-feature.module'
import { HeaderIntroTextFeatureModule } from './header-intro-text/header-intro-text-feature.module'
import { HeaderIntroTextForProtocolFeatureModule } from './header-intro-text-for-protocol/header-intro-text-for-protocol-feature.module'
import { HeaderSliderHomepageFeatureModule } from './header-slider-homepage/header-slider-homepage-feature.module'
import { HeaderVideoFeatureModule } from './header-video/header-video-feature.module'
import { SlashHeaderFeatureModule } from './slash-header/slash-header-feature.module'
import { SlimHeaderFeatureModule } from './slim-header/slim-header-feature.module'
import { SmallHeaderFeatureModule } from './small-header/small-header-feature.module'

@NgModule({
  imports: [
    FullWidthHeaderFeatureModule,
    HeaderImageFeatureModule,
    HeaderImageBackgroundFeatureModule,
    HeaderIntroTextFeatureModule,
    HeaderIntroTextForProtocolFeatureModule,
    HeaderSliderHomepageFeatureModule,
    HeaderVideoFeatureModule,
    SlashHeaderFeatureModule,
    SlimHeaderFeatureModule,
    SmallHeaderFeatureModule
  ]
})
export class HeaderRootModule {}
